import React, { useEffect, useState } from 'react';
import { Typography, useTheme } from '@mui/material';
import { useLocation } from 'react-router-dom-v5-compat';
import { useUrlParams } from '@/hooks';
import { ConnectionFailed } from '@/resources/images';
import { createThirdPartyConnection } from '@/modules/dataWrangler/dataWrangler';
import useStyles from './styles';
import WarnConfirmDialog from '../WarnConfirmDialog';

const ThirdPartyDisconnectionModal = () => {
    const theme = useTheme();
    const classes = useStyles(theme);

    const [open, setOpen] = useState(false);
    const location = useLocation();
    const { getUrlParams } = useUrlParams();

    const pathName = location.pathname;

    const urlParams = getUrlParams();
    const accountSuccess = urlParams?.success;
    const processor = urlParams?.processor;

    const closeAndRedirectToStripeAccountCreationLink = async () => {
        setOpen(false);
        window.location = await createThirdPartyConnection(processor);
    };

    useEffect(() => {
        if (
            accountSuccess === 'false' &&
            pathName === '/settings/payment-methods'
        )
            setOpen(true);
    }, [accountSuccess, pathName]);

    return (
        <WarnConfirmDialog
            onConfirm={closeAndRedirectToStripeAccountCreationLink}
            onCancel={() => setOpen(false)}
            customIcon={<ConnectionFailed className={classes.icon} />}
            confirmColor={theme.palette.primary.main}
            message={
                <Typography color="textPrimary">
                    An error has occured while trying to connect your account.
                </Typography>
            }
            confirmText="Try Again"
            large
            open={open}
        />
    );
};

export default ThirdPartyDisconnectionModal;
